import {
  AlexaVisibilityQuestion,
  AlexaVisibilityQuestionSet
} from '@blisspointmedia/bpm-types/dist/AlexaVisibility';
import { DropdownOption } from '@Components/Dropdown/dropdown-constants';

// Mirrors MAX_QUESTIONS_PER_CLIENT in bpm-lambdas' alexaVisibilityQuestionStore.ts.
export const MAX_QUESTIONS = 200;

export const ENTITY_NAME = 'alexa_visibility_questions';

export const QUESTION_SET_OPTIONS: DropdownOption<AlexaVisibilityQuestionSet>[] = [
  { label: 'Both sets', value: 'both' },
  { label: 'Set A only', value: 'a' },
  { label: 'Set B only', value: 'b' }
];

export const NEW_QUESTION: AlexaVisibilityQuestion = {
  query: '',
  querySet: 'both',
  enabled: true
};

export interface DraftQuestion extends AlexaVisibilityQuestion {
  // Stable React key for an editable row; never sent to the API.
  rowId: string;
}
